// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__28hGH","description":"PatientConsentPreview_description__2Z0kf"};